import React, { useState, useEffect, useRef } from "react";
import { Link, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./login.css";
import {
  initialErrors,
  fieldValidation,
} from "../../common/helper/form-constants.js";
import { MESSAGES } from "../../constants/constants.js";
import { FormField, SelectField } from "./../../common/helper/formFields";

import { verifyEmailAddress } from "./../../../actions/auth-actions";
import LoginService from "./../../../services/auth-service";
import { useSelector } from "react-redux";
import LoaderOverlay from "./../../common/helper/loader.component.js";
import { toast } from "react-toastify";
import useIsMobile from "../../common/hooks/useIsMobile.js";
const ResetPassword = () => {
  const [errors, setErrors] = useState({ ...initialErrors });
  const [email, setEmailAddress] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [passwordChange, setPasswordChange] = useState({});
  const userData = useSelector((state) => state.authReducer);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(30); // 30-second timer
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [timer, setTimer] = useState(null);
  const isMobile=useIsMobile();
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibilityconfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };

  const updateTime = (prevTime, setIsButtonEnabled, timer) => {
    if (prevTime <= 1) {
      clearInterval(timer); // Clear the interval if the timer reaches zero
      setIsButtonEnabled(true); // Enable the button
      return 0; // Reset the timer
    }
    return prevTime - 1; // Otherwise, decrease the timer by 1
  };

  // Define the function to start the timer
  const startTimer = () => {
    if (timer) {
      clearInterval(timer); // Clear any existing timer
    }
    setIsButtonEnabled(false); // Disable the button
    setTimeLeft(30); // Reset timer to 30 seconds
    const newTimer = setInterval(() => {
      setTimeLeft((prevTime) =>
        updateTime(prevTime, setIsButtonEnabled, newTimer)
      );
    }, 1000);
    setTimer(newTimer); // Store the new timer
  };

  useEffect(() => {
    if (userData.verifyEmail) {
      setEmailAddress(userData.verifyEmail.email);
    }
    document.body.style.backgroundImage = "url('assets/download.jpeg')";
    document.body.style.backgroundSize = "cover";

      document.getElementsByClassName("reset-passwrd")[0].style.backgroundImage="url('assets/img6.avif')";
      document.getElementsByClassName("reset-passwrd")[0].style.backgroundSize = "cover";

    startTimer(); // Start the initial timer when the component is mounted

    return () => {
      clearInterval(timer); // Clear the timer on unmount
      // document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
  }, []);

  const handleChangePassword = (e) => {
    const { name, value } = e.target;
    setPasswordChange((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    // if (name === 'newPassword') {
    //   validateField('confirmationPassword', passwordChange.confirmationPassword);
    // }
  };
  const validateField = (fieldName, value) => {
    let errorMessage = fieldValidation(fieldName, value);
    if (fieldName === "confirm_password") {
      if (value && value !== passwordChange.new_password) {
        errorMessage = "Password and confirm password not matched";
      }
    }
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

  const digit1Ref = useRef(null);
  const digit2Ref = useRef(null);
  const digit3Ref = useRef(null);
  const digit4Ref = useRef(null);

  // Handle input change and move focus to the next field
  const handleChange = (e, nextRef) => {
    const { name, value } = e.target;
    setPasswordChange((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
    if (e.target.value.length === 1) {
      if (nextRef && nextRef.current) {
        nextRef.current.focus(); // Move to the next input
      }
    }
  };

  // Handle backspace to move focus to the previous field
  const handleKeyDown = (e, prevRef) => {
    if (e.key === "Backspace" && e.target.value.length === 0) {
      if (prevRef && prevRef.current) {
        prevRef.current.focus(); // Move to the previous input
      }
    }
  };
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach((fieldName) => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue.trim()) {
        validateField(fieldName, fieldValue || "");
        isValid = false;
      }
    });
    return isValid;
  };

  const updatePassword = (e) => {
    e.preventDefault();
    const requiredFields = [
      "new_password",
      "confirm_password",
      "digit1",
      "digit2",
      "digit3",
      "digit4",
    ];
    if (!validateFields(requiredFields, passwordChange)) return;
    const hasErrors = Object.values(passwordChange).some(
      (value) => value === ""
    );
    console.log(passwordChange);
    if (!hasErrors) {
      setLoading(true);
      const obj = {
        otp:
          passwordChange.digit1 +
          passwordChange.digit2 +
          passwordChange.digit3 +
          passwordChange.digit4,
        new_password: passwordChange.new_password,
        email: email,
      };
      LoginService.resetPassword(obj)
        .then((response) => {
          setLoading(false);
          toast.success(MESSAGES.PWD_RESET);
          navigate("/");
        })
        .catch((error) => {
          setLoading(false);
          try {
            const errorMessage = error.response.data;
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
          } catch (e) {
            toast.error(MESSAGES.SERVER_ERROR);
          }
        });
    }
  };
  const resendOTP = () => {
    setLoading(true);
    LoginService.newOTP({ email: email })
      .then((response) => {
        setLoading(false);
        startTimer(); // Restart the timer

        toast.success(MESSAGES.OTP_SEND);
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
  };

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid vh-100 m-0" style={{padding:isMobile?"0px" :"50px 120px", }}>
        <div className="row h-100 m-0 p-0" style={{borderRadius:isMobile? "20px":"40px", overflow:"hidden"}}>
          <div className="col-lg-7 d-none d-lg-block p-0 position-relative">
            <img
              src="assets/img9.avif"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                opacity: "0.8",
              }}
            ></img>
            <div
              className="position-absolute bottom-0 start-0 p-5 text-white"
              style={{
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
              }}
            >
              <h2
                className="display-5 fw-bold mb-3 text-white"
                style={{ color: "white" }}
              >
                 {process.env.REACT_APP_TITLE}
              </h2>
              <p className="fs-5 text-white" style={{ color: "white" }}>
                Giving you more autonomy to control your money.
              </p>
              <div style={{ border: "1px solid white", width: "120px" }}></div>
            </div>
          </div>

          <div className="reset-passwrd col-12 col-lg-5 d-flex align-items-center justify-content-center bg-white " style={{padding:"0 40px "}}>
            <div className=" container px-6 reset-psswrd">
              <div className="text-center mb-4">
                <a href="#">
                  <img style={{ width: "200px" }} src="assets/logo1.png" />
                </a>
                <h6 style={{ marginTop: "15px" }} className="text-uppercase">
                  Reset Password
                </h6>
              </div>
              <form
                method="post"
                id="reset_password_form"
                onSubmit={updatePassword}
                name="reset_password_form"
                action="#"
                noValidate="novalidate"
              >
                <div className="form-group first">
                  <label className="required" htmlFor="password">
                    Email
                  </label>
                  <input
                    type="text"
                    name="email"
                    className="form-control"
                    id="email"
                    value={email}
                    required
                    disabled
                  />
                </div>
                <div className="form-group first">
                  <label className="required" htmlFor="password">
                    OTP
                  </label>
                  <br />
                  <input
                    type="text"
                    className={`form-control otpInput ${
                      errors.digit1 ? "is-invalid" : ""
                    }`}
                    maxLength={1}
                    name="digit1"
                    id="digit1"
                    ref={digit1Ref}
                    onChange={(e) => handleChange(e, digit2Ref)}
                    onKeyDown={(e) => handleKeyDown(e, null)} // No previous ref for the first input
                    autoComplete="off" // Disable autofill
                  />
                  <input
                    type="text"
                    className={`form-control otpInput ${
                      errors.digit2 ? "is-invalid" : ""
                    }`}
                    maxLength={1}
                    id="digit2"
                    name="digit2"
                    ref={digit2Ref}
                    onChange={(e) => handleChange(e, digit3Ref)}
                    onKeyDown={(e) => handleKeyDown(e, digit1Ref)}
                    autoComplete="off" // Disable autofill
                  />
                  <input
                    type="text"
                    className={`form-control otpInput ${
                      errors.digit3 ? "is-invalid" : ""
                    }`}
                    maxLength={1}
                    id="digit3"
                    name="digit3"
                    ref={digit3Ref}
                    onChange={(e) => handleChange(e, digit4Ref)}
                    onKeyDown={(e) => handleKeyDown(e, digit2Ref)}
                    autoComplete="off" // Disable autofill
                  />
                  <input
                    type="text"
                    className={`form-control otpInput ${
                      errors.digit4 ? "is-invalid" : ""
                    }`}
                    maxLength={1}
                    name="digit4"
                    id="digit4"
                    ref={digit4Ref}
                    onChange={(e) => handleChange(e, null)} // No next ref for the last input
                    onKeyDown={(e) => handleKeyDown(e, digit3Ref)}
                    autoComplete="off" // Disable autofill
                  />
                  <div
                    className="container"
                    style={{ padding: 0, display: "inline-flex" }}
                  >
                    <div className="col-md-4" style={{ padding: 0 }}>
                      <div style={{ textAlign: "left" }}>
                        <button className="rsendbtn " id="resendBtn" disabled style={{color:"#495a69"}}>
                          {`00:${String(timeLeft).padStart(2, "0")}`}{" "}
                          {/* Display the timer */}
                        </button>
                      </div>
                    </div>
                    <div
                      className="col-md-4 otpd"
                      style={{ padding: 0, paddingLeft: "5px" }}
                    >
                      <div style={{ textAlign: "left" }}>
                        <button
                          onClick={resendOTP}
                          className="rsendbtn"
                          id="resendBtnm"
                          disabled={!isButtonEnabled} // Disable based on state
                          type="button"
                          style={{ opacity: isButtonEnabled ? "1.0" : "0.5", color:"#495a69" }}
                        >
                          Resend OTP
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group first">
                  <FormField
                    type={showPassword ? "text" : "password"}
                    isRequierd={true}
                    id="password"
                    name="new_password"
                    label="New Password"
                    placeholder="Enter New Password"
                    value={setPasswordChange.new_password}
                    onChange={handleChangePassword}
                    error={errors.new_password}
                    maxLength={20}
                    isPassword={true}
                  />
                  <i
                    className={`toggle-password fa fa-fw ${
                      showPassword ? "fa-eye" : "fa-eye-slash"
                    }`}
                    onClick={togglePasswordVisibility}
                  />
                  {errors.new_password && (
                    <div className="invalid-feedback">
                      {errors.new_password}
                    </div>
                  )}
                </div>
                <div className="form-group last mb-5">
                  <FormField
                    type={showPasswordConfirm ? "text" : "password"}
                    isRequierd={true}
                    id="password"
                    name="confirm_password"
                    label="Confirm Password"
                    placeholder="Enter Confirm Password"
                    value={setPasswordChange.confirm_password}
                    onChange={handleChangePassword}
                    error={errors.confirm_password}
                    maxLength={20}
                    isPassword={true}
                  />
                  <i
                    className={`toggle-password fa fa-fw ${
                      showPasswordConfirm ? "fa-eye" : "fa-eye-slash"
                    }`}
                    onClick={togglePasswordVisibilityconfirm}
                  />
                  {errors.confirm_password && (
                    <div className="invalid-feedback">
                      {errors.confirm_password}
                    </div>
                  )}
                </div>
                <input
                  style={{ fontSize: "15px" }}
                  type="submit"
                  defaultValue="Reset Password"
                  className="btn btn-block py-2 resetpassword btn-bg-theme-Color"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
